import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw';

dayjs.locale('zh-tw');

/** 統一格式化日期，避免依賴瀏覽器 locale。 */
export function formatDate(value: dayjs.ConfigType): string {
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '—';
}

/** 顯示工作台標題用的中文長日期。 */
export function formatLongDate(value: dayjs.ConfigType): string {
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('YYYY年M月D日 dddd') : '—';
}

/** 統一格式化日期時間，固定 24 小時制。 */
export function formatDateTime(value: dayjs.ConfigType): string {
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss') : '—';
}

/** 統一格式化時間，固定 24 小時制。 */
export function formatTime(value: dayjs.ConfigType): string {
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('HH:mm:ss') : '—';
}
